module.exports = __webpack_public_path__ + "static/logo-cba722a323cfc0c2a042dfb74715901c.png";